import { render, staticRenderFns } from "./everyday-stretches-a45.vue?vue&type=template&id=4dc5de3d"
import script from "./everyday-stretches-a45.vue?vue&type=script&lang=js"
export * from "./everyday-stretches-a45.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports